import React from 'react';

import { BenchmarkConfig } from '../types';

interface BenchmarkBarProps {
  config: BenchmarkConfig;
  visible: boolean;
  children?: React.ReactNode;
}

export const BenchmarkBar: React.FC<BenchmarkBarProps> = ({ config, visible, children }) => {
  const [animated, setAnimated] = React.useState(false);

  React.useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => setAnimated(true), 300);
      return () => clearTimeout(timer);
    }
    setAnimated(false);
  }, [visible]);

  const revealClass = animated ? 'reveal-space reveal-opacity' : '';
  const revealOpacity = animated ? 'reveal-opacity' : '';

  let marketStatusText = 'At Market level';
  if (config.userPercent < config.marketAveragePercent) {
    marketStatusText = 'Under market';
  } else if (config.userPercent > config.marketAveragePercent) {
    marketStatusText = 'Above the market';
  }

  return (
    <div className={`ms-benchmark-container${animated ? ' active-bg' : ''}`}>
      {/* Left: Competitors analyzed */}
      <div className={`ms-bm-left ${revealClass}`}>
        <span className="ms-bm-label">Package Benchmark</span>
        <span className={`ms-bm-value ${revealOpacity}`}>
          {marketStatusText}
        </span>
      </div>

      {/* Divider */}
      <div className={`ms-bm-divider ${revealOpacity}`} />

      {/* Center: Bar */}
      <div className={`ms-bm-center ${revealClass}`}>
        <span className={`ms-bm-vs-market ${revealOpacity}`}>You vs. Market</span>
        <div className={`ms-bm-track-container ${revealOpacity}`}>
          <div className="ms-bm-track">
            {/* Market hashed fill */}
            <div
              className={`ms-bm-fill ms-bm-fill--market ${revealOpacity}`}
              style={{ width: animated ? `${config.marketAveragePercent}%` : '0%' }}
            />
            {/* User blue fill */}
            <div
              className={`ms-bm-fill ms-bm-fill--you ${revealOpacity}`}
              style={{ width: animated ? `${config.userPercent}%` : '0%' }}
            />

            {/* Pins */}
            {Math.abs(config.userPercent - config.marketAveragePercent) < 2 ? (
              <div
                className={`ms-fp-pin ms-fp-pin--combined ${revealOpacity}`}
                style={{ left: animated ? `${config.userPercent}%` : '0%' }}
                data-edge={config.userPercent >= 100 ? 'right' : config.userPercent <= 0 ? 'left' : undefined}
              >
                <div className="ms-fp-pin-label ms-fp-pin-label--combined">{config.userLabel}</div>
                <div className="ms-fp-pin-below">
                  <div className="ms-fp-pin-arrow" />
                  <div className="ms-fp-pin-text">You and Market</div>
                </div>
              </div>
            ) : (
              <>
                <div
                  className={`ms-fp-pin ms-fp-pin--you ${revealOpacity}`}
                  style={{ left: animated ? `${config.userPercent}%` : '0%' }}
                  data-edge={config.userPercent >= 100 ? 'right' : config.userPercent <= 0 ? 'left' : undefined}
                >
                  <div className="ms-fp-pin-label ms-fp-pin-label--you">
                    {/* {config.userLabel} */}
                  </div>
                  <div className="ms-fp-pin-below">
                    <div className="ms-fp-pin-arrow" />
                    <div className="ms-fp-pin-text">You</div>
                  </div>
                </div>

                <div
                  className={`ms-fp-pin ms-fp-pin--market ${revealOpacity}`}
                  style={{ left: animated ? `${config.marketAveragePercent}%` : '0%' }}
                  data-edge={config.marketAveragePercent >= 100 ? 'right' : config.marketAveragePercent <= 0 ? 'left' : undefined}
                >
                  {/* <div className="ms-fp-pin-label ms-fp-pin-label--market">
                    {config.marketLabel}
                  </div> */}
                  <div className="ms-fp-pin-below">
                    <div className="ms-fp-pin-arrow" />
                    <div className="ms-fp-pin-text">Market</div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className={`ms-bm-divider ${revealOpacity}`} />

      {/* Right: Competitors (passed as children) */}
      {children}
    </div>
  );
};
